import { ViewLiveWebinarOrganism } from '@online-webinar/player';
import { useParams } from '@online-webinar/router';
import { useEffect } from 'react';

export const ViewLiveWebinarPage = ({ countdownImageUrl, countdownVideoUrl }: { countdownImageUrl?: string; countdownVideoUrl?: string }) => {
    const { webinarId, linkCode } = useParams({ strict: false });

    useEffect(() => {
        document.body.classList.add('no-menu');
        return () => {
            document.body.classList.remove('no-menu');
        };
    }, []);

    return <ViewLiveWebinarOrganism webinarId={webinarId!} linkCode={linkCode} countdownImageUrl={countdownImageUrl} countdownVideoUrl={countdownVideoUrl} />;
};
